module.exports = __webpack_public_path__ + "img/tuiguang2-1-2.5dcc9c94.png";